import { __awaiter, __generator } from "tslib";
import { createFloaterMenuDriver } from '../../drivers';
import { compKey } from './key';
export var createItemMenuWithImageDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    return {
        getMenuTitles: function () { return __awaiter(void 0, void 0, void 0, function () {
            var menuTitles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, createFloaterMenuDriver(base.$('.menu-items')).getItems()];
                    case 1:
                        menuTitles = _a.sent();
                        return [2 /*return*/, menuTitles.map(function (title) { return title.trim(); })];
                }
            });
        }); },
        getSideBarTitle: function () { return base.$('.side-bar-title').text(); },
        getSideBarDescription: function () { return base.$('.side-bar-description').text(); },
        dividerExists: function (menuOptionId) { return base.$(".divider-" + menuOptionId).exists(); },
        mouseOver: function (menuOptionId) { return base.$(".title-" + menuOptionId).hover(); },
        clickTitle: function (menuOptionId) { return base.$(".menu-item-" + menuOptionId).click(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map